import React from 'react';
import '../styles/Footer.css';
import logo from '../assets/logo.png';
import { PHONE_NUMBER, EMAIL_ADDRESS } from '../App.js';


const Footer = () => {
  return (
    <footer className="footer">
      <div className='footerContents'>
        <div className='footerLogo'>
          <a href='/'>
          <img src={logo} alt="PaperForLess Logo" className="logo" />
          </a>
        </div>
        <div className='footerSection'>
          <h4>Contact Us</h4>
          <ul>
            <li><i class="fas fa-phone-alt"></i> Call Now: {PHONE_NUMBER}</li>
            <li><i class="fas fa-envelope"></i> Email Inqury: {EMAIL_ADDRESS}</li>
          </ul>
        </div>
        <div className='footerSection'>
          <h4><a href="/quote" className="btn">Request a Quote</a></h4>
        </div>
        <div className='footerSection'>
          <h4>About Us</h4>
          <p>
          At PaperForLess, we believe printing should be seamless and sustainable. Our high-performance paper is designed for a wide range of uses, from vibrant color printing to everyday documents. Driven by innovation and customer satisfaction, we continuously improve our products to meet the evolving needs of our clients.
          </p>
        </div>
      </div>
      <span className='divider'><hr></hr></span>
      <p>© 2024 PaperForLess</p>
      {/* <p><a href="/contact">Contact Us</a></p> */}
    </footer>
  );
};

export default Footer;
